const SET_AREA_TABLE = (state, payload) => {
    state.area_table = payload.data
}

const SET_PROVINCE_OPTIONS = (state, payload) => {
    state.province_options = []
    for (let i = 0; i < payload.data.length; ++i) {
        state.province_options.push({
            id: payload.data[i].code,
            label: payload.data[i].name
        })
    }
}

const SET_REGENCY_OPTIONS = (state, payload) => {
    state.regency_options = []
    for (let i = 0; i < payload.data.length; ++i) {
        state.regency_options.push({
            id: payload.data[i].code,
            label: payload.data[i].name
        })
    }
}

const SET_DISTRICT_OPTIONS = (state, payload) => {
    state.district_options = []
    for (let i = 0; i < payload.data.length; ++i) {
        state.district_options.push({
            id: payload.data[i].code,
            label: payload.data[i].name
        })
    }
}

const RESET_AREA_FORM = (state) => {
    state.area_form = {
        province_code: null,
        regency_code: null,
    }
}

const RESET_REGENCY_OPTIONS = (state) => {
    state.regency_options = []
}

const RESET_DISTRICT_OPTIONS = (state) => {
    state.district_options = []
}

export {
    SET_AREA_TABLE,
    SET_PROVINCE_OPTIONS,
    SET_REGENCY_OPTIONS,
    SET_DISTRICT_OPTIONS,
    RESET_AREA_FORM,
    RESET_REGENCY_OPTIONS,
    RESET_DISTRICT_OPTIONS,
}